const filterItems = {
	'text': {
		base: { xtype: 'textfield', labelAlign: 'top' },
		choices: {
			包含: ['like'],
			等于: ['='],
			范围: ['>=', '<='],
			不包含: ['!like'],
			不等于: ['!='],
		}
	},
	'int': {
		base: { xtype: 'numberfield', labelAlign: 'top', /* labelWidth: 'auto', */ decimals: 0 },
		choices: {
			范围: ['>=', '<='],
			等于: ['='],
			不等于: ['!=']
		}
	},
	'number': {
		base: { xtype: 'numberfield', labelAlign: 'left', labelWidth: 'auto' },
		choices: {
			范围: ['>=', '<='],
			等于: ['='],
			不等于: ['!=']
		}
	},
	'float': {
		base: { xtype: 'numberfield', labelAlign: 'left', labelWidth: 'auto' },
		choices: {
			范围: ['>=', '<='],
			等于: ['='],
			不等于: ['!=']
		}
	},
	'date': {
		base: { xtype: 'datefield', labelAlign: 'left', labelWidth: 'auto', floatedPicker: { captionFormat: 'Y F', header: { hidden: false } }, clearable: true },
		choices: {
			范围: ['>=', '<='],
			等于: ['='],
			早于: ['<='],
			晚于: ['>='],
			不等于: ['!=']
		}
	},
	'datetime': {
		base: { xtype: 'tyandatetimefield', labelAlign: 'left', labelWidth: 'auto', floatedPicker: { captionFormat: 'Y F', header: { hidden: false } } },
		choices: {
			范围: ['>=', '<='],
			等于: ['='],
			早于: ['<='],
			晚于: ['>='],
			不等于: ['!=']
		}
	},
	'select': {
		base: { xtype: 'checkbox' },
		choices: {
			包含: ['in'],
			不包含: ['!in']
		}
	}
}

// Date.UTC(inputValue.getFullYear(), inputValue.getMonth(), inputValue.getDate()).valueOf()

// Calculate every dataType's maxops
Object.values(filterItems).forEach(v => v.choices && (v.maxops = Object.values(v.choices).reduce((s, a) => Math.max(s, a.length), 0)))

const filterTypes = Object.keys(filterItems)
var choicesWidth = 63
// locale
Tyan.onReady(() => {
	var temp
	Object.values(filterItems).forEach(({ choices }) =>
		choices && Object.entries(choices).forEach(([key, value]) => {
			key != (temp = Tyan.t(key, 'columnFilter')) && (delete choices[key], choices[temp] = value)
		}))
	choicesWidth = parseInt(Tyan.t('标签宽度', 'columnFilter')) || choicesWidth
})

export default filterTypes


// return {items, count} 
// items: 菜单项，个数为1的数组
// count: 其中明细数量，针对select即为options长度，针对其它则为filterItems中choices中属性值(数组)的最大长度
export const getFilterItems = ({ filter, filterProp, filterChoices, onFilterChange, selectValues = [], isGroup = false }) => {
	const name = filter.name
	const dataType = filter.type
	const config = filterItems[filter.type]
	const choices = config.choices
	const choiceValues = choices && (filterChoices[name] = filterChoices[name] || Object.entries(choices)[0])

	const getFilterValue = (type) => {
		var value = filterProp[name] && filterProp[name][type]
		value && dataType === 'date' && (value = new Date(value)) && (value = new Date(value.getUTCFullYear(), value.getUTCMonth(), value.getUTCDate()))
		return value
	}

	const setFilterValue = (type, value) => {
		if (value || (typeof value === 'number' && value === 0)) {
			value = dataType === 'date'
				? [Date.UTC(value.getFullYear(), value.getMonth(), value.getDate()).valueOf(), filter.options || 'D']
				: dataType === 'datetime'
					? [Tyan.Date.localToUtcValue(value), filter.options || 'm']
					: value
			filterProp[name] = filterProp[name] || {}
			filterProp[name][type] = value
		} else {
			filterProp[name] && filterProp[name][type] && delete filterProp[name][type]
			filterProp[name] && Object.keys(filterProp[name]).length == 0 && delete filterProp[name]
		}
	}

	const handleFilterValueChange = ({ type, opi, subName }) => (input, value, oldValue) => {
		switch (dataType) {
			case 'select':  // opi:0, subName:selectedItem
				const currValue = choiceValues[opi + 2] || []
				value && !currValue.includes(subName) && currValue.push(subName)
				!value && currValue.includes(subName) && currValue.splice(currValue.indexOf(subName), 1)
				value = currValue.length ? currValue : null
				break

			default:  // opi: index in filterChoices[name][1], used to save value in filterChoices[name][opi+2]
				value && dataType === 'text' && typeof value === 'string' && (value = value.trim())
				typeof value === 'number' && dataType === 'int' && (value = Math.round(value))
				break
		}
		// save value in filterChoices
		choiceValues[opi + 2] = value

		// type (op)
		setFilterValue(choiceValues[1][opi], value)

		onFilterChange && onFilterChange(filterProp)
	}

	const handleChoiceChange = (cbx, nv, ov) => {
		choiceValues[0] = nv
		choiceValues[1] = choices[nv]
		const inputs = cbx.next().getItems().items
		for (let i = 0; i < config.maxops; i++)
			i >= choiceValues[1].length ? inputs[i].hide() : inputs[i].show()

		// change values in filterProp
		const changed = !!filterProp[name]
		delete filterProp[name]

		choiceValues[1].forEach((op, i) => setFilterValue(op, choiceValues[i + 2]));
		; (changed || filterProp[name]) && onFilterChange && onFilterChange(filterProp)
	}

	const items = []
	let count = config.maxops

	const getInputs = () => {
		const subItems = []

		switch (filter.type) {
			case 'select':
				const currValue = choiceValues[2] || []
				filter.options.forEach((option, index) => subItems.push({
					...config.base,
					boxLabel: option || `<${Tyan.t('空', 'columnFilter')}>`,
					// tooltip: option || `<${Tyan.t('空', 'columnFilter')}>`,
					/* labelAlign: 'left', labelTextAlign: 'left', flex: 0,  */bodyAlign: 'start', /* margin: '0px 10px 0px 0px',  *//* boxLabelAlign: 'after', */
					checked: currValue.includes(option),
					listeners: { change: handleFilterValueChange({ opi: 0, subName: option }) },
					// ...(isGroup ? { minWidth: 100, margin: '0 10 0 0' } : {}),
					minWidth: 100, margin: '0 10 0 0',
					flex: 0,
				}))
				count = filter.options.length
				break

			default:
				for (let i = 0; i < config.maxops; i++)
					subItems.push({
						...config.base, margin: '0 10 4 0', style: { padding: '0' },
						value: choiceValues[i + 2],
						listeners: { change: handleFilterValueChange({ opi: i }) },
						minWidth: 200, maxWidth: 260, flex: 1, hidden: i >= choiceValues[1].length
					})
				break
		}
		return {
			xtype: 'container', flex: 1, items: subItems,
			layout: filter.type === 'select' ? { type: 'hbox', align: 'start', wrap: true } : 'vbox'
		}
	}

	let subItems = []
	if (Object.keys(choices).length > 1) {
		subItems.push({
			xtype: 'combobox', editable: false, forceSelection: true, width: choicesWidth, margin: '0 10 0 0',
			options: Object.keys(choices), value: choiceValues[0],
			listeners: { change: handleChoiceChange }
		})
	} else {
		subItems.push({ xtype: 'label', html: choiceValues[0], width: choicesWidth, margin: '0 5 0 0' })
	}
	subItems.push(getInputs())
	items.push({ xtype: 'container', layout: { type: 'hbox', align: 'start' }, flex: 1, items: subItems })
	// config.labels.forEach((label, index) => items.push({
	//   ...config.base,
	//   ...(isGroup && { labelAlign: 'left', labelWidth: 'auto', margin: '0 10 0 0' }),
	//   label,
	//   value: getFilterValue(filterProp, name, config.types[index], filter.type),
	//   listeners: { change: handleFilterValueChange({ name, type: config.types[index], dataType: filter.type }, filterProp, onFilterChange) },
	//   minWidth: 200, maxWidth: 260,
	//   flex: 1
	// }))

	return { items, count }
}

